import axios from "axios";
import React, { useEffect, useState } from "react";

import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from "react-icons/md";
import ApartmentBlock1 from "../SvgImages/ApartmentBlock1";
import PenthouseBlock1 from "../SvgImages/PenthouseBlock1";
import ApartmentBlock2 from "../SvgImages/ApartmentBlock2";
import ApartmentBlock3 from "../SvgImages/ApartmentBlock3";

function BlockComponents({
  showBlock,
  setShowBlock,
  rooms,
  floor,
  setRooms,
  setSelectedUnit,
  selectedFloor,
  handleAhedRooms,
  blockId,
}) {
  const [pdf, setPdf] = useState("");
  useEffect(() => {
    const getAzhaPdf = async () => {
      const res = await axios.get(
        "https://saroojdevelopment.com/laravel/public/api/community-pdf/azha-apartments"
      );
      setPdf(res?.data.azhapdf);
    };

    getAzhaPdf();
  }, []);
  return (
    showBlock && (
      <div
        onClick={() => {
          setShowBlock(false);
          setSelectedUnit(null);

          setRooms([]);
        }}
        className="z-[200] animate-zoom-in  top-0 left-0 w-full h-full bg-[#000000bb] flex justify-center items-center"
      >
        <div className="bg-[white] relative h-[90%] md:h-[60%]  flex md:flex-col justify-evenly w-[90%] ">
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-[80%] md:w-[100%]  bg-[white] md:justify-center flex justify-evenly"
          >
            <div
              className={` ${
                blockId === "block3"
                  ? "h-[100%] md:items-center md:h-[75%]  md:justify-center  lg:pl-[2%] md:pl-[0%] flex justify-center font-[cairo]"
                  : " md:items-center   lg:pl-[2%] md:pl-[0%] flex justify-center md:justify-end  font-[cairo]"
              } `}
            >
              {blockId === "block1" && (
                <>
                  {floor?.find((f) => f.id === selectedFloor)?.community_id ===
                    4 &&
                  floor?.find((f) => f.id === selectedFloor)?.floor === "PH" ? (
                    <div className="w-[100%] h-full">
                      <PenthouseBlock1 rooms={rooms} />
                    </div>
                  ) : (
                    <div className="w-[100%] h-full">
                      <ApartmentBlock1 rooms={rooms} />
                    </div>
                  )}
                </>
              )}
              {blockId === "block2" && (
                <>
                  <div className="w-[100%] h-full">
                    <ApartmentBlock2 rooms={rooms} />
                  </div>
                </>
              )}
              {blockId === "block3" && (
                <>
                  <div className="w-[100%] h-full">
                    <ApartmentBlock3 rooms={rooms} />
                  </div>
                </>
              )}
            </div>

            {blockId === "block1" && (
              <div className=" flex w-[80%] md:w-[100%] sm:justify-center justify-end gap-[2%] top-2 lg:top-1 h-[fit-content] absolute">
                <div className="animate-bounce  w-[fit-content]">
                  <a
                    href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[fit-content] font-bold text-[18px] lg:text-[12px]  hover:text-[gray] hover:underline cursor-pointer"
                  >
                    Download Our brochure
                  </a>
                </div>
                <div className="flex gap-[5px]">
                  <p className="p-[5px] lg:p-[2px] lg:text-[11px] md:text-[10px] md:h-[20px] rounded-[5px] bg-[#008000b4]">
                    Available
                  </p>
                  <p className="p-[5px] lg:p-[2px] lg:text-[11px] md:text-[10px] md:h-[20px] rounded-[5px] bg-[#b6b60eb0]">
                    Booked
                  </p>
                  <p className="p-[5px] lg:p-[2px] lg:text-[11px] md:text-[10px] md:h-[20px] rounded-[5px] bg-[#ff0000a9]">
                    Sold
                  </p>
                </div>
              </div>
            )}
            {blockId === "block2" && (
              <div className=" md:text-[12px] flex justify-end items-end lg:justify-center  gap-[2%] lg:items-center md:text-end px-[1.5%] absolute w-[100%] top-[10px] md:justify-end">
                <div className="animate-bounce md:my-[1%]  md:text-end text-end ">
                  <a
                    href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[fit-content] font-bold text-[18px] lg:text-[12px]  hover:text-[gray] hover:underline cursor-pointer"
                  >
                    Download Our brochure
                  </a>
                </div>
                <div className="flex gap-[5px]  justify-end ">
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#008000b4]">
                    Available
                  </p>
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#b6b60eb0]">
                    Booked
                  </p>
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#ff0000a9]">
                    Sold
                  </p>
                </div>
              </div>
            )}

            {blockId === "block3" && (
              <div className=" md:text-[12px] flex  gap-[2%] flex-col py-[2%] justify-start  px-[1.5%] absolute top-[10px] left-[1px] lg:justify-center md:justify-end">
                <div className="animate-bounce md:my-[2%] ">
                  <a
                    href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[fit-content] font-bold text-[18px] lg:text-[12px]  hover:text-[gray] hover:underline cursor-pointer"
                  >
                    Download Our brochure
                  </a>
                </div>
                <div className=" md:text-[12px] flex  gap-[5px] top-[10px]">
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#008000b4]">
                    Available
                  </p>
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#b6b60eb0]">
                    Booked
                  </p>
                  <p className="p-[5px] md:p-[1%] rounded-[5px] bg-[#ff0000a9]">
                    Sold
                  </p>
                </div>
              </div>
            )}
          </div>
          <div
            onClick={(e) => e.stopPropagation()}
            className="text-white h-[fit-content] rounded-[5px] bg-[#2c2c2c] my-[5%]  flex  justify-center items-center flex-col p-[1%]"
          >
            <p className="text-start w-full lg:text-[12px]">Floors</p>
            <div className=" w-[100%] flex flex-col md:flex-row  justify-center items-center gap-[10px]">
              <div className="bg-[#222222] md:rotate-[-90deg] cursor-not-allowed md:w-[35px]  w-[100%] flex justify-center rounded-t-[10px]">
                <MdOutlineArrowDropUp className="text-[30px]" />
              </div>

              <div className="flex flex-col md:flex-row  gap-[10px]">
                {floor?.map((floors) => (
                  <p
                    key={floors.id}
                    className={`h-[50px] rounded-[5px] cursor-pointer w-[50px] lg:w-[33px] lg:h-[33px] border text-center flex justify-center items-center  ${
                      selectedFloor === floors.id ? "bg-[gray]" : ""
                    } hover:bg-[gray] transition-all duration-500 ease-in-out`}
                    onClick={() => handleAhedRooms(floors.id)}
                  >
                    {floors.floor}
                  </p>
                ))}
              </div>
              <div className="bg-[#222222] md:rotate-[-90deg] cursor-not-allowed md:w-[35px] w-[100%] flex justify-center rounded-b-[10px]">
                <MdOutlineArrowDropDown className="text-[30px]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default BlockComponents;
